<template>
  <div>
    <BaseBrandedHeader />

    <div class="d-flex flex-wrap justify-content-center container-fluid">

      <div class="p-4 mb-5 mx-5 bg-light border-0 shadow-lg">
          <h3><b>Settings</b></h3>

          <div class="form-group">
            <label class="col-form-label">Blog Name</label>
            <div>
              <input class="inline-form-control text-right" type="text" v-model="blog_name">
              <small>.tumblr.com</small>
            </div>
          </div>

          <div class="form-group">
            <label class="col-form-label">Dimensions</label>
            <div>
              <input class="inline-form-control" size="4" type="text" v-model="height">
              X
              <input class="inline-form-control" size="4" type="text" v-model="width">
            </div>
          </div>

          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input"
                      type="checkbox"
                      value=""
                      id="show_description"
                      v-model="show_description">
              <label class="form-check-label" for="show_description">
                Show Blog Description
              </label>
            </div>
          </div>

          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input"
                      type="checkbox"
                      value=""
                      id="show_notes"
                      v-model="show_notes">
              <label class="form-check-label" for="show_notes">
                Show Notes Count
              </label>
            </div>
          </div>

          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input"
                      type="checkbox"
                      value=""
                      id="show_tags"
                      v-model="show_tags">
              <label class="form-check-label" for="show_tags">
                Show Tags
              </label>
            </div>
          </div>

          <div class="form-group">
              <verte class="mr-2"
                    picker="square"
                    model="hex"
                    v-model="background_color"></verte>
            <label class="form-check-label" for="header_footer_color">
                Background Color
            </label>

          </div>

          <div class="form-group">
              <verte class="mr-2"
                    picker="square"
                    model="hex"
                    v-model="header_footer_color"></verte>
            <label class="form-check-label" for="header_footer_color">
                Header & Footer Color
            </label>

          </div>

          <hr class="my-5" />

          <h3><b>Widget Embed Code </b></h3>
          <div class="form-group">
              <label class="col-form-label">Copy & Paste into your website</label>
              <div>
                <textarea class="form-control w-100 text-monospace widget-embed-code"
                          rows="3"
                          v-model="embed_code">
                </textarea>
              </div>
          </div>
      </div>

      <iframe :src="embed_url"
            v-bind:width="width"
            v-bind:height="height"
            class="border-0 shadow-lg rounded-lg mx-5">
      </iframe>


    </div>

    <BaseBrandedFooter />
  </div>
</template>

<script>
import Verte from 'verte';
import BaseBrandedFooter from '@/components/BaseBrandedFooter.vue';
import BaseBrandedHeader from '@/components/BaseBrandedHeader.vue';
import 'verte/dist/verte.css';


export default {
  name: 'home',
  components: {
    Verte,
    BaseBrandedFooter,
    BaseBrandedHeader,
  },
  data() {
    return {
      blog_name: 'costcopizzablog',
      width: '600',
      height: '600',
      show_description: true,
      show_notes: true,
      show_tags: true,
      header_footer_color: '#133d43',
      background_color: '#56847b',
    };
  },
  computed: {
    embed_url() {
      const backgroundColor = this.background_color.substr(1);
      const headerFooterColor = this.header_footer_color.substr(1);

      return `/#/embed/${this.blog_name}/${this.show_description}/${this.show_notes}/${this.show_tags}/${backgroundColor}/${headerFooterColor}/`;
    },
    embed_code() {
      return `<iframe src="${process.env.VUE_APP_BASE_URL}${this.embed_url}" width="${this.width}" height="${this.height}"></iframe>`;
    },
  },
  methods: {
  },
};
</script>

<style>
.verte {
  display: inline;
}

iframe {
  border: none;
}

.widget-embed-code {
  font-size: 12px;
  resize: vertical;
  min-height: 110px;
}
</style>
